import PropTypes from "prop-types";

import Loader from "shared/components/feedback/loading/Loader";
import { COLOR_VALUES } from "shared/config/colors";
import Icon, { ICON_NAMES } from "shared/components/utils/Icon";
import Tooltip from "shared/components/utils/tooltip/Tooltip";
import { InlineBlockToPreventTooltipDisabledButtonError, StyledQuaternaryButton, StyledText } from "./QuaternaryButton.styles";

const QuaternaryButton = ({
    loading = false,
    label,
    labelColor,
    leadingIcon,
    leadingIconColor,
    trailingIcon,
    ...rest
}) => {
    const ariaLabel = rest["aria-label"];

    if (!label && !ariaLabel) {
        console.error("Icon-only button missing aria-label");
    }

    return (
        <>
            {loading ? (
                <Loader width={18} height={18} color={COLOR_VALUES.Gray_1} />
            ) : (
                <Tooltip text={ariaLabel} enabled={!label}>
                    <InlineBlockToPreventTooltipDisabledButtonError>
                        <StyledQuaternaryButton {...rest}>
                            {leadingIcon && (
                                <Icon
                                    size={14}
                                    name={leadingIcon}
                                    color={leadingIconColor}
                                />
                            )}
                            {label && (
                                <StyledText
                                    $color={labelColor}
                                    variant="Descriptive_1_1"
                                >
                                    {label}
                                </StyledText>
                            )}
                            {trailingIcon && (
                                <Icon size={14} name={trailingIcon} />
                            )}
                        </StyledQuaternaryButton>
                    </InlineBlockToPreventTooltipDisabledButtonError>
                </Tooltip>
            )}
        </>
    );
};

QuaternaryButton.propTypes = {
    loading: PropTypes.bool,
    label: PropTypes.string,
    labelColor: PropTypes.string,
    leadingIcon: PropTypes.oneOf(ICON_NAMES),
    leadingIconColor: PropTypes.string,
    trailingIcon: PropTypes.oneOf(ICON_NAMES),
    "aria-label": PropTypes.string,
    disabled: PropTypes.bool,
};

export default QuaternaryButton;
